import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'
import {FormattedMessage} from 'react-intl'

const style = { width: 101,  height: 26 }

export function draft(props) {
  return (
    <SvgIcon style={ style } viewBox="0 0 101 26" {...props}>
      <g fill="none" fillRule="evenodd" transform="translate(-41 -768)">
        <rect width="99" height="25" x="41.904" y="768.614" fill="#F5BD23" rx="3"/>
        <text fill="#FFF" fontFamily="Montserrat,sans-serif" fontSize="9" fontWeight="bold">
            <tspan x="82.226" y="784.304"><FormattedMessage id="deal.status.draft" /></tspan>
        </text>
        <path fill="#FFF" fillRule="nonzero" stroke="#FFF" strokeWidth=".8" d="M64.516 778.088a1.932 1.932 0 0 0-.391-.63l-2.54-2.586a1.893 1.893 0 0 0-.618-.398 1.85 1.85 0 0 0-.716-.165h-5.209a.746.746 0 0 0-.553.232.774.774 0 0 0-.228.563v11.14c0 .222.076.41.228.564a.747.747 0 0 0 .553.232h8.855a.747.747 0 0 0 .553-.232.775.775 0 0 0 .228-.563v-7.427c0-.221-.054-.464-.162-.73zm-4.005-2.652a.886.886 0 0 1 .334.182l2.548 2.595c.064.066.124.18.178.34h-3.06v-3.117zm3.126 10.544h-8.334v-10.61h4.167v3.448c0 .22.076.409.227.563a.747.747 0 0 0 .554.233h3.386v6.366z"/>
      </g>
    </SvgIcon>
  )
}

export function pendingReview(props) {
  return (
    <SvgIcon style={ style } viewBox="0 0 101 26" {...props}>
      <g fill="none" fillRule="evenodd" transform="translate(-41 -698)">
        <rect width="99" height="25" x="41.904" y="698.614" fill="#F5BD23" rx="3"/>
        <text fill="#FFF" fontFamily="Montserrat,sans-serif" fontSize="9" fontWeight="bold">
            <tspan x="76.731" y="714.304"><FormattedMessage id="deal.status.pending_review" /></tspan>
        </text>
        <g stroke="#FFF" strokeWidth="2" transform="translate(52.687 705.114)">
            <circle cx="6.326" cy="6.036" r="5.994"/>
            <path strokeLinecap="square" strokeLinejoin="round" d="M5.845 2.966v3.563l2.258 1.972"/>
        </g>
      </g>
    </SvgIcon>
  )
}

export function approved(props) {
  return (
    <SvgIcon style={ style } viewBox="0 0 101 26" {...props}>
      <g fill="none" fillRule="evenodd" transform="translate(.421)">
        <rect width="99" height="25" x=".982" fill="#90C814" rx="3"/>
        <text fill="#FFF" fontFamily="Montserrat,sans-serif" fontSize="9" fontWeight="bold">
            <tspan x="31.945" y="16.19"><FormattedMessage id="deal.status.approved" /></tspan>
        </text>
        <g stroke="#FFF" strokeWidth="2" transform="translate(11.5 7)">
            <circle cx="6.714" cy="6.036" r="5.994"/>
            <path d="M4.243 5.685l2.062 2.528L9.41 3.376"/>
        </g>
      </g>
    </SvgIcon>
  )
}

export function rejected(props) {
  return (
    <SvgIcon style={ style } viewBox="0 0 101 26" {...props}>
      <g fill="none" fillRule="evenodd" transform="translate(.421)">
        <rect width="99" height="25" x=".482" fill="#6AAEAA" rx="3"/>
        <text fill="#FFF" fontFamily="Montserrat,sans-serif" fontSize="9" fontWeight="bold">
            <tspan x="35.407" y="16.48"><FormattedMessage id="deal.status.rejected" /></tspan>
        </text>
        <circle cx="6.011" cy="5.735" r="5.695" stroke="#FFF" strokeWidth="2" transform="translate(12.246 7.265)"/>
        <path fill="#FFF" d="M17.43 9.803h1.867l-.374 4.393h-1.12l-.372-4.393zm.934 6.614a.799.799 0 1 1 0-1.597.799.799 0 0 1 0 1.597z"/>
      </g>
    </SvgIcon>
  )
}

export function published(props) {
  return (
    <SvgIcon style={ style } viewBox="0 0 101 26" {...props}>
      <g fill="none" fillRule="evenodd" transform="translate(.421)">
        <rect width="99" height="25" x=".982" fill="#90C814" rx="3"/>
        <text fill="#FFF" fontFamily="Montserrat,sans-serif" fontSize="9" fontWeight="bold">
            <tspan x="31.712" y="16.19"><FormattedMessage id="deal.status.published" /></tspan>
        </text>
        <g stroke="#FFF" strokeWidth="2" transform="translate(11.5 7)">
            <circle cx="6.714" cy="6.036" r="5.994"/>
            <path d="M4.243 5.685l2.062 2.528L9.41 3.376"/>
        </g>
      </g>
    </SvgIcon>
  )
}

export function active(props) {
  return (
    <SvgIcon style={ style } viewBox="0 0 101 26" {...props}>
      <defs>
        <path id="a" d="M8.399 1.62c-.19-.078-.379.051-.379.232v.98c0 .181.109.362.27.44 1.434.774 2.353 2.323 2.137 4.052-.216 1.884-1.812 3.433-3.813 3.64-2.596.283-4.813-1.678-4.813-4.105 0-1.523.865-2.865 2.163-3.587a.497.497 0 0 0 .27-.44v-.98c0-.18-.188-.31-.378-.232-2.298.903-3.894 3.174-3.65 5.756.243 2.658 2.46 4.826 5.246 5.136 3.569.361 6.624-2.297 6.624-5.653 0-2.374-1.514-4.388-3.677-5.24zM6.939.536c0-.207-.19-.388-.406-.388h-.811c-.216 0-.406.181-.406.388v4.387c0 .207.19.388.406.388h.811c.217 0 .406-.181.406-.388V.536z"/>
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(.421)">
        <rect width="99" height="25" x=".482" fill="#90C814" rx="3"/>
        <text fill="#FFF" fontFamily="Montserrat,sans-serif" fontSize="9" fontWeight="bold">
            <tspan x="42.306" y="16.48"><FormattedMessage id="deal.status.active" /></tspan>
        </text>
        <use fill="#FFF" stroke="#FFF" strokeWidth=".5" transform="translate(11.186 6.309)" xlinkHref="#a"/>
      </g>
    </SvgIcon>
  )
}

export function closed(props) {
  return (
    <SvgIcon style={ style } viewBox="0 0 101 26" {...props}>
      <g fill="none" fillRule="evenodd" transform="translate(-41 -838)">
        <rect width="99" height="25" x="41.904" y="838.614" fill="#6AAEAA" rx="3"/>
        <text fill="#FFF" fontFamily="Montserrat,sans-serif" fontSize="9" fontWeight="bold">
            <tspan x="79.076" y="854.304"><FormattedMessage id="deal.status.closed" /></tspan>
        </text>
        <g transform="translate(52.687 845.114)">
            <circle cx="5.994" cy="5.994" r="5.994" stroke="#FFF" strokeWidth="2"/>
            <path fill="#FFF" d="M3 5h6v2H3z"/>
        </g>
      </g>
    </SvgIcon>
  )
}

export function unknown(props) {
  return (
    <SvgIcon style={ style } viewBox="0 0 101 26" {...props}>
      <g fill="none" fillRule="evenodd" transform="translate(.421)">
        <rect width="99" height="25" x=".482" fill="#6AAEAA" rx="3"/>
        <text fill="#FFF" fontFamily="Montserrat,sans-serif" fontSize="9" fontWeight="bold">
            <tspan x="35.407" y="16.48">!!!!!!</tspan>
        </text>
        <circle cx="6.011" cy="5.735" r="5.695" stroke="#FFF" strokeWidth="2" transform="translate(12.246 7.265)"/>
        <path fill="#FFF" d="M17.43 9.803h1.867l-.374 4.393h-1.12l-.372-4.393zm.934 6.614a.799.799 0 1 1 0-1.597.799.799 0 0 1 0 1.597z"/>
      </g>
    </SvgIcon>
  )
}